function oktPointToGeoJSONPoint (oktPoint) {
  return [parseFloat(oktPoint.Lng), parseFloat(oktPoint.Lat)];
}

const OktShapePathToGeoJSONGeometry = {
  "polygon": (path) => (
    {
      'type': "Polygon",
      'coordinates': [[...path.map(oktPointToGeoJSONPoint), oktPointToGeoJSONPoint(path[0])]]
    }
  )
};

export function oktToGeoJSON ({Poligonos}) {
  return Poligonos.map(({ Shape, Html, Opacidad }) => (
    Shape.map(({ Id, Readonly, FillCssColor, FillOpacity, StrokeWeight, StrokeColor, Type, Path }) => (
      {
        "type": "Feature",
        "properties": {
          "html": Html,
          "mapOpacity": Opacidad,
          "id": Id,
          "readOnly": Readonly,
          "fillCssColor": FillCssColor,
          "fillOpacity": FillOpacity,
          "strokeWeight": StrokeWeight,
          "strokeColor": StrokeColor
        },
        "geometry": OktShapePathToGeoJSONGeometry[Type](Path)
      }
    ))
  )).reduce((a, b) => (
    a.concat(b)
  ))
}



// WEBPACK FOOTER //
// ./src/utils/oktInterop.js